import Mousetrap from 'mousetrap'

/*
* Allows the user to tab through the buttons shown on exit confirmation modals, using Mousetrap.js
* Confirmation modal buttons must have the 'exit-modal-btn' class
* @param {Boolean} dialogVisible
* @return void
*/
export function tabThruModalButtons (btnClassName = null) {
  if (btnClassName) {
    let btns = document.getElementsByClassName(btnClassName)
    let activeBtnIndex = 0
    Mousetrap.bind('tab', function () {
      btns[activeBtnIndex].focus()
      if (activeBtnIndex >= (btns.length - 1)) {
        activeBtnIndex = 0
      } else {
        activeBtnIndex++
      }
      return false
    })
  } else {
    Mousetrap.unbind('tab')
  }
}

export function submitOnEnter (form, submitFunc) {
  if (form && submitFunc) {
    Mousetrap(form).bind('enter', () => submitFunc())
  } else {
    Mousetrap.unbind('enter')
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/KeyNavHelper.js